(() => {
  const mountReveal = (element) => {
    element.classList.add('is-mounted');

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      element.classList.add('is-visible');
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      if (!entries[0]?.isIntersecting) return;
      element.classList.add('is-visible');
      observer.disconnect();
    }, { threshold: 0.1 });

    observer.observe(element);
  };

  class OndeliePdpRevealSection extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      mountReveal(this);
    }
  }

  ['ondelie-pdp-ritual', 'ondelie-pdp-outcomes', 'ondelie-pdp-installation'].forEach((tag) => {
    if (!customElements.get(tag)) customElements.define(tag, class extends OndeliePdpRevealSection {});
  });

  if (!customElements.get('ondelie-pdp-faq')) {
    customElements.define('ondelie-pdp-faq', class extends OndeliePdpRevealSection {
      connectedCallback() {
        super.connectedCallback();
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-opq-question]');
          if (button && this.contains(button)) this.toggleItem(button);
        });
      }

      toggleItem(button) {
        const item = button.closest('[data-opq-item]');
        const panel = item?.querySelector('[data-opq-answer]');
        if (!item || !panel) return;

        const shouldOpen = button.getAttribute('aria-expanded') !== 'true';
        item.classList.toggle('is-open', shouldOpen);
        button.setAttribute('aria-expanded', String(shouldOpen));
        panel.hidden = !shouldOpen;
      }
    });
  }
})();
